export default "__VITE_ASSET__ChwNXf6Y__"